import { render, staticRenderFns } from "./MdTextarea.vue?vue&type=template&id=860a0a36&scoped=true&"
import script from "./MdTextarea.vue?vue&type=script&lang=js&"
export * from "./MdTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "860a0a36",
  null
  
)

export default component.exports